<template>
	<az-container class="penalidades mt-4">
		<az-toolbar class="interna az-toolbar">
			<template #actions v-if="totalItens">
				<botao-primario
					v-if="exibirBotaoAdicionar()"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalPenalidade"
					v-az-auth="permissoes.ataPenalidadesCriar"
				>
				</botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por: tipo, fornecedor ou órgão"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</template>
		</az-toolbar>

		<listagem-itens
			:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
			:colunas="getColunas()"
			:custom-columns="['valor']"
			:itens="datasource"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem()"
			:tamanho-maximo-colunas="getTamanhoMaximoColunas()"
			show-actions
			listagem-vazia-custom
			listagem-vazia-custom-class="listagem-vazia"
		>
			<template #actions="{ item }">
				<listagem-penalidades-botoes-acoes
					@excluir="abrirOuFecharModalConfirmacaoExcluirPenalidade(item)"
					@editar="abrirModalPenalidade(item)"
					@visualizar="visualizarPenalidade(item)"
					@historico-notificacoes="abrirOuFecharModalHistoricoNotificacao(item)"
					:item="item"
					:usuario-eh-gestor="usuarioEhGestor"
				></listagem-penalidades-botoes-acoes>
			</template>
			<template #acoes-listagem-vazia>
				<botao-primario
					v-if="exibirBotaoAdicionar()"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalPenalidade"
					v-az-auth="permissoes.ataPenalidadesCriar"
				>
				</botao-primario>
			</template>
		</listagem-itens>

		<modal-penalidade
			v-if="exibirModalPenalidade"
			:exibir="exibirModalPenalidade"
			:is-visualizar="isVisualizar"
			@fechar-modal="fecharModalPenalidade"
			:id-entidade="$route.params.id"
			:entidade-tipo="tipoPenalidade.ATA_REGISTRO_PRECO"
			:titulo-modal="getTituloModalPenalidade"
			:id-ata="$route.params.id"
			:penalidade="penalidadeSelecionadaEditar"
			:id-pasta-externa-digital="idPastaExternaDigital"
			:notificacao-obrigatoria="penalidadeAtaObrigatoriaInfracao"
		>
			<template #listagem-documentos-entidade>
				<documentos-penalidade-ata
					:id-ata="$route.params.id"
					:modo-visualizacao="isVisualizar"
				></documentos-penalidade-ata>
			</template>
		</modal-penalidade>

		<modal-confirmacao
			:exibir="exibirModalConfirmacaoExcluirPenalidade"
			titulo-modal="Excluir"
			subtitulo-modal="Deseja realmente excluir?"
			mensagem="A infração/sanção excluída não poderá ser recuperada!"
			@fechar-modal="abrirOuFecharModalConfirmacaoExcluirPenalidade"
			@confirmar="excluirPenalidade"
		></modal-confirmacao>

		<modal-historico-notificacoes
			v-if="exibirModalHistoricoNotificacao"
			:exibir="exibirModalHistoricoNotificacao"
			:entidade-tipo="tipoPenalidade.ATA_REGISTRO_PRECO"
			titulo-modal="Histórico de Notificações"
			@fechar-modal="abrirOuFecharModalHistoricoNotificacao"
			:item="penalidadeSelecionadaHistorico"
		></modal-historico-notificacoes>
	</az-container>
</template>
<script>
import ModalPenalidade from '@/views/components/penalidade/ModalPenalidade'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import { actionTypes, permissoes, tipoPenalidade } from '@/core/constants'
import ListagemItens from '@/views/components/ListagemItens.vue'
import ListagemPenalidadesBotoesAcoes from '@/views/pages/ata/acessar/penalidades/acoes/ListagemPenalidadesBotoesAcoes.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { TabelaColunaUtils } from '@/core/utils'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import { mapState } from 'vuex'
import DocumentosPenalidadeAta from '@/views/pages/ata/acessar/penalidades/documentos/DocumentosPenalidadesAta'
import ModalHistoricoNotificacoes from '@/views/components/ModalHistoricoNotificacoes.vue'

export default {
	name: 'penalidades-view',
	components: {
		ModalHistoricoNotificacoes,
		DocumentosPenalidadeAta,
		ModalConfirmacao,
		ListagemPenalidadesBotoesAcoes,
		ListagemItens,
		BotaoPrimario,
		ModalPenalidade,
	},
	filters: {},
	data() {
		return {
			idEntidade: this.$route.params.id,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			filtro: {
				nomeFornecedorOuNomeOrgaoSancionadorOuTipoPenalidade: {
					default: null,
					label: 'Pesquisa',
					value: null,
				},
			},
			isComponenteAtivo: true,
			exibirModalPenalidade: false,
			penalidadeSelecionadaEditar: null,
			exibirModalConfirmacaoExcluirPenalidade: false,
			isVisualizar: false,
			penalidadeSelecionadaExcluir: null,
			usuarioPodeAdicionar: false,
			usuarioEhGestor: false,
			exibirModalHistoricoNotificacao: false,
			penalidadeSelecionadaHistorico: null,
		}
	},
	computed: {
		...mapState({
			idPastaExternaDigital: (state) => state.ata.informacoesAta.idPastaExternaDigital,
			numeroCasasDecimaisValores: (state) => state.ata.informacoesAta.numeroCasasDecimaisValores,
			penalidadeAtaObrigatoriaInfracao: (state) => state.parametrosSistema.penalidadeAtaObrigatoriaInfracao,
		}),
		tipoPenalidade() {
			return tipoPenalidade
		},
		textosDaListagemVazia() {
			const textos = { titulo: 'Você não possui infrações e sanções cadastradas.' }

			if (this.verificarPermissao(permissoes.ataPenalidadesCriar) && this.exibirBotaoAdicionar()) {
				textos['mensagem'] = 'Clique no botão para adicionar'
			}

			return textos
		},
		getTituloModalPenalidade() {
			if (this.penalidadeSelecionadaEditar) return 'Editar Infrações e Sanções'
			return 'Infrações e Sanções'
		},
	},
	async mounted() {
		await Promise.all([await this.buscarPermissoes(), await this.buscarPenalidades()])
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		async buscarPenalidades() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_PENALIDADES,
				this.montarPayloadBuscarPenalidades(),
			)

			this.datasource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async buscarPermissoes() {
			const response = await this.$store.dispatch(actionTypes.PENALIDADES.VALIDAR_PENALIDADES, {
				idEntidade: this.idEntidade,
				tipo: tipoPenalidade.ATA_REGISTRO_PRECO,
			})

			this.usuarioPodeAdicionar = response.usuarioPodeAdicionar
			this.usuarioEhGestor = response.usuarioEhGestor
		},
		montarPayloadBuscarPenalidades() {
			return {
				filtro: { ...this.filtro },
				idEntidade: { value: this.idEntidade },
				tipo: tipoPenalidade.ATA_REGISTRO_PRECO,
				paginacao: this.paginacao,
			}
		},
		exibirBotaoAdicionar() {
			return this.usuarioPodeAdicionar || this.usuarioEhGestor
		},
		buscar(searchText) {
			if (searchText) {
				this.filtro.nomeFornecedorOuNomeOrgaoSancionadorOuTipoPenalidade.value = searchText.trim()
			}
			this.resetarPaginaListagem()
		},
		removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			this.resetarPaginaListagem()
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarPenalidades()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarPenalidades()
		},
		getColunas() {
			const cols = [
				new TabelaColunaUtils('Fornecedor', 'nomeFornecedor', '30%'),
				new TabelaColunaUtils('Órgão', 'orgaoSancionador', '15%'),
				new TabelaColunaUtils('Origem', 'origem', '20%'),
				new TabelaColunaUtils('Tipo', 'tipo', '10%'),
			]

			if (
				this.verificarPermissao(
					this.permissoes.ataPenalidadesVisualizar,
					this.permissoes.ataPenalidadesExcluir,
					this.permissoes.ataPenalidadesEditar,
				)
			) {
				cols.push(new TabelaColunaUtils('Ações', 'actions', '15%'))
			}

			return cols
		},
		getTamanhoMaximoColunas() {
			return {
				nomeFornecedor: 55,
				orgaoSancionador: 20,
				origem: 25,
				tipo: 30,
				valor: 15,
				situacao: 10,
			}
		},
		abrirModalPenalidade(penalidade) {
			this.isVisualizar = false
			this.penalidadeSelecionadaEditar = penalidade
			this.exibirModalPenalidade = true
		},
		visualizarPenalidade(penalidade) {
			this.isVisualizar = true
			this.penalidadeSelecionadaEditar = penalidade
			this.exibirModalPenalidade = true
		},
		async fecharModalPenalidade() {
			this.penalidadeSelecionadaEditar = null
			this.exibirModalPenalidade = false
			await this.buscarPenalidades()
		},
		abrirOuFecharModalConfirmacaoExcluirPenalidade(penalidade) {
			this.penalidadeSelecionadaExcluir = penalidade
			this.exibirModalConfirmacaoExcluirPenalidade = !this.exibirModalConfirmacaoExcluirPenalidade
		},
		async excluirPenalidade() {
			await this.$store
				.dispatch(actionTypes.PENALIDADES.EXCLUIR_PENALIDADE, {
					penalidade: this.penalidadeSelecionadaExcluir,
					tipo: tipoPenalidade.ATA_REGISTRO_PRECO,
				})
				.then(() => this.mostrarNotificacaoSucessoDefault())

			this.abrirOuFecharModalConfirmacaoExcluirPenalidade()
			await this.resetarPaginaListagem()
		},
		abrirOuFecharModalHistoricoNotificacao(penalidade) {
			this.penalidadeSelecionadaHistorico = penalidade
			this.exibirModalHistoricoNotificacao = !this.exibirModalHistoricoNotificacao
		},
	},
}
</script>
<style lang="stylus">
.penalidades

	.listagem-vazia
		padding 0.5rem 1.5rem
		margin 1.25rem

	.interna
		background-color white !important
		border none !important

	.az-toolbar
		height auto !important

	.az-toolbar .actions
		padding 0 !important

	.icon-search
		margin-right 0 !important
</style>
